module.exports = __webpack_public_path__ + "img/addWx.65109e7d.png";